export const LoadingPage = () => {
  return (
    <p className="justify-center items-center text-green-gray text-xl font-extrabold text-center">
      Loading...
    </p>
  );
};
